/**
 * @file 检测元素是否在视野里
 * @author FengGuang(fengguang01@baidu.com)
 *
 */
import {MutableRefObject, useEffect, useState} from 'react';
import throttle from 'lodash/throttle';


const useElementInView = <T extends HTMLElement>(ref: MutableRefObject<T | null | undefined>) => {
    const [isInView, setIsInView] = useState(false);

    useEffect(() => {
        if (ref.current) {
            const handle = () => {
                if (ref.current) {
                    const rect = ref.current.getBoundingClientRect();
                    const height = window.innerHeight || document.documentElement.clientHeight;
                    const width = window.innerWidth || document.documentElement.clientWidth;

                    // 纵轴在视野内
                    const verticalIsInView = !(rect.top > height || rect.bottom < 0);
                    // 横轴在视野内
                    const horizontalIsInView = !(rect.left > width || rect.right < 0);

                    if (verticalIsInView && horizontalIsInView) {
                        setIsInView(true);
                    }
                    else {
                        setIsInView(false);
                    }
                }
            };
            const handleThrottle = throttle(handle, 100);

            handle();

            window.addEventListener('scroll', handleThrottle);
            return () => {
                window.removeEventListener('scroll', handleThrottle);
            };
        }
    }, [ref, setIsInView]);

    return isInView;
};

export default useElementInView;
